import { type RouteRecordRaw } from 'vue-router'

// Todo : A supprimer
export const ROUTE_CONTEXT_FAIL = 'context-akto-fail'
export const PATH_CONTEXT_FAIL = `/${ROUTE_CONTEXT_FAIL}`

export const contextAppRoutes: Array<RouteRecordRaw> = [
  {
    path: PATH_CONTEXT_FAIL,
    name: ROUTE_CONTEXT_FAIL,
    component: () => import('../views/FailContextView.vue'),
  },
]
